var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingActions24PxBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pending_actions-24px") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-\\u6CA1\\u6709list",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assessments-pending",
    transform: "translate(-1322.000000, -125.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pending_actions-24px",
    transform: "translate(1322.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,12 C14.24,12 12,14.24 12,17 C12,19.76 14.24,22 17,22 C19.76,22 22,19.76 22,17 C22,14.24 19.76,12 17,12 Z M18.65,19.35 L16.5,17.2 L16.5,14 L17.5,14 L17.5,16.79 L19.35,18.64 L18.65,19.35 Z M18,3 L14.82,3 C14.4,1.84 13.3,1 12,1 C10.7,1 9.6,1.84 9.18,3 L6,3 C4.9,3 4,3.9 4,5 L4,20 C4,21.1 4.9,22 6,22 L12.11,22 C11.52,21.43 11.04,20.75 10.69,20 L6,20 L6,5 L8,5 L8,8 L16,8 L16,5 L18,5 L18,10.08 C18.71,10.18 19.38,10.39 20,10.68 L20,5 C20,3.9 19.1,3 18,3 Z M12,5 C11.45,5 11,4.55 11,4 C11,3.45 11.45,3 12,3 C12.55,3 13,3.45 13,4 C13,4.55 12.55,5 12,5 Z",
    id: "\\u5F62\\u72B6",
    fill: "#0E78D5",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingActions24PxBlue);
export default __webpack_public_path__ + "static/media/pending_actions-24px-blue.e8f18e5a.svg";
export { ForwardRef as ReactComponent };